var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgLiveDot = function SvgLiveDot(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10.577 10.566"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#0CEB66",
    fillRule: "evenodd",
    d: "M5.288 0a5.286 5.286 0 0 1 5.289 5.283 5.286 5.286 0 0 1-5.289 5.283A5.286 5.286 0 0 1 0 5.283 5.286 5.286 0 0 1 5.288 0",
    clipRule: "evenodd"
  })));
};
export default SvgLiveDot;